export const SOFTLINE_API_MDE_BESTELLVORSCHLAG_BEWEGUNGEN = '/v1/bestellvorschlag/bewegung/entities'
export const SOFTLINE_API_MDE_BESTELLVORSCHLAG_ABSCHLUSS = '/v1/bestellvorschlag/abschluss'
export const SOFTLINE_API_MDE_BESTELLVORSCHLAG = '/v1/bestellvorschlag'
export const SOFTLINE_API_MDE_BESTELLVORSCHLAG_ARTIKEL = '/v1/bestellvorschlag/artikel/entities'
export const SOFTLINE_API_MDE_BESTELLVORSCHLAG_ARTIKEL_DETAIL = 'detail'
